import React from 'react'
import {Icon} from '@chakra-ui/react'
const CalendarIcon = (props) => {
    return (
        <Icon viewBox="0 0 24 24" {...props}>
            <path d="M7.48371 14.4517H5.16113V16.7742H7.48371V14.4517Z" fill="currentColor" />
            <path d="M13.1614 14.4517H10.8389V16.7742H13.1614V14.4517Z" fill="currentColor" />
            <path d="M18.8387 14.4517H16.5161V16.7742H18.8387V14.4517Z" fill="currentColor" />
            <path
                d="M0 24H24V3.09677H18.8387V0H17.5484V3.09677H6.45161V0H5.16129V3.09677H0V24ZM1.29032 4.3871H22.7097V8.61936H1.29032V4.3871ZM1.29032 9.99226H22.7097V22.7097H1.29032V9.99226Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default CalendarIcon
